import { createContext } from 'react';
import { TermsForSearch } from './types';

export const FilteredProfileTermsContext = createContext<TermsForSearch>([]);
FilteredProfileTermsContext.displayName = 'FilteredProfileTermsContext';

export const ProfileTermsContext = createContext<TermsForSearch>([]);
ProfileTermsContext.displayName = 'ProfileTermsContext';
